/** Minimale lengte van een wachtwoord; dezelfde eis als bij aanmelden. */
export const MINIMALE_LENGTE = 8;

/**
 * Controleert een nieuw gekozen wachtwoord. Geeft de foutmelding voor het
 * scherm terug, of null als het goed is.
 */
export function controleerNieuwWachtwoord(wachtwoord: string, herhaling: string): string | null {
  if (wachtwoord.length < MINIMALE_LENGTE) {
    return 'Kies een wachtwoord van minstens acht tekens.';
  }
  if (wachtwoord !== herhaling) {
    return 'De twee wachtwoorden zijn niet gelijk.';
  }
  return null;
}
